import React, { useRef, useState, useCallback, useEffect } from 'react';
import {
  TextField,
  ReferenceField,
  ListBase,
  ListToolbar,
  Pagination,
  FunctionField,
  useRefresh,
  usePermissions,
  Title,
  useListContext,
  Datagrid,
  ListContextProvider,
} from 'react-admin';
import { useHistory } from 'react-router-dom';

import { Card, Divider, Tabs, Tab } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import { DialogoConfirmacao } from '../../Components';
import DialogoPrecificacao from '../../Components/Dialogos/DialogoMargeamento';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import {
  round10,
  formatMoeda,
  getEstoqueLabel,
  POR_UNIDADE,
  POR_PESO_VARIAVEL_SEM_UNIDADE,
  POR_PESO_FIXO,
  TIPO_IMPRESSAO_UN,
  getPrecoUnitarioVerdadeiroCaixa2,
} from '../../utils';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
import {
  PERMISSAO_TELA_PRODUTOS_ABA_INATIVOS,
  PERMISSAO_TELA_PRODUTOS_CRIAR,
  PERMISSAO_TELA_PRODUTOS_INATIVAR,
  PERMISSAO_TELA_PRODUTOS_LISTAR,
} from '../../utils/dadosTelas';
import DialogoTesteNfceVenda from '../Vendas/DialogoTesteNfceVenda';
import ActionsField from './ActionsField';
import Actions from './ActionsList';
import AreaCopiaCola from './AreaCopiaCola';
import ContainerDialogoImprimirCartazes from './ContainerDialogoImprimirCartazes';
import Dialogo from './ContainerDialogoProduto';
import DialogoChangeRuptura from './DialogoChangeRuptura';
import DialogoChangeSearch from './DialogoChangeSearch';
import DialogoConferir from './DialogoConferir';
import DialogoImagem from './DialogoImagem';
import DialogoShowProduto from './DialogoShow';
import Filter from './Filter';
import ValorField from './ValorField';

const tabs = [
  { id: 'ativos', name: 'Ativos' },
  { id: 'inativos', name: 'Inativos' },
];

function getUnidade(produto) {
  if (produto.unidade.tipo === POR_UNIDADE) return 'Un';
  if (produto.unidade.tipo === POR_PESO_VARIAVEL_SEM_UNIDADE) return 'Kg';
  if (produto.unidade.tipo === POR_PESO_FIXO) {
    if (produto.tipo_impressao === TIPO_IMPRESSAO_UN) return 'Un';
    return 'Kg';
  }
  return '';
}

function getFator(produto) {
  if (produto.unidade.tipo === POR_UNIDADE) return 1;
  if (produto.unidade.tipo === POR_PESO_VARIAVEL_SEM_UNIDADE) return 1;
  if (produto.unidade.tipo === POR_PESO_FIXO) {
    if (produto.tipo_impressao === TIPO_IMPRESSAO_UN) return produto.peso_medio;
    return 1;
  }
  return '';
}

const postRowStyle = (record, index) => {
  const produto = record;
  if (produto) {
    if (
      produto.unidade.tipo === POR_UNIDADE ||
      produto.unidade.tipo === POR_PESO_FIXO
    ) {
      if (produto.unidadesDisponivel <= 0) {
        return {
          backgroundColor: '#f44336ac',
        };
      }
    }

    if (produto.unidade.tipo === POR_PESO_VARIAVEL_SEM_UNIDADE) {
      if (produto.pesoDisponivel <= 0) {
        return {
          backgroundColor: '#f44336ac',
        };
      }
    }
  }

  return {
    backgroundColor: 'white',
  };
};

const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  // criar, inativar e ver a aba "Inativos" dependem de permissão própria.
  const { permissions } = usePermissions();
  const podeCriar = Boolean(
    permissions && permissions[PERMISSAO_TELA_PRODUTOS_CRIAR],
  );
  const podeInativar = Boolean(
    permissions && permissions[PERMISSAO_TELA_PRODUTOS_INATIVAR],
  );
  const podeVerInativos = Boolean(
    permissions && permissions[PERMISSAO_TELA_PRODUTOS_ABA_INATIVOS],
  );
  const abas = podeVerInativos
    ? tabs
    : tabs.filter((aba) => aba.id === 'ativos');
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const history = useHistory();
  const refDialogoConfirmacao = useRef(null);
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const refDialogoCompra = useRef(null);
  const refDialogoConferir = useRef(null);
  const refDialogoChangeStatusSearch = useRef(null);
  const refDialogoShowProduto = useRef(null);

  const refDialogoChangeStatusRuptura = useRef(null);

  const refDialogoPrecificacao = useRef(null);

  const refDialogoImprimirCartazes = useRef(null);

  const refAreaCopiaCola = useRef(null);
  const refDialogoTesteNfceVenda = useRef(null);

  const refDialogoImagem = useRef(null);

  function handleImprimirCartaz({ id }) {
    if (refDialogoImprimirCartazes.current) {
      refDialogoImprimirCartazes.current.handleOpen(id);
    }
  }

  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate(1);
    }
  }

  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }

  function handleShow({ id }) {
    //history.push(`/produtos/${id}/show`);
    if (refDialogoShowProduto.current) {
      refDialogoShowProduto.current.handleOpen(id);
    }
  }

  function handleAtivar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Reativação de Produto',
        'Deseja realmente reativar este produto?',
        { id, codigo: 1 },
      );
    }
  }

  function handleDesativar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Desativação de Produto',
        'Deseja realmente desativar este produto?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Exclusão de Produto',
        'Deseja deletar permanentemente este produto?',
        { id, codigo: 3 },
      );
    }
  }

  async function ativar(id) {
    const response = await api.put(`/produtos/status/ativar/${id}`);
    const { status, message, data } = response.data;

    if (status) {
      handleClose();
      enqueueSnackbar('Produto ativado com sucesso!', {
        variant: 'success',
      });
    } else {
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  }

  async function desativar(id) {
    const response = await api.put(`/produtos/status/inativar/${id}`);

    const { status, message, data } = response.data;
    if (status) {
      handleClose();
      enqueueSnackbar('Produto inativado com sucesso!', {
        variant: 'success',
      });
    } else {
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  }

  async function deletar(id) {
    const response = await api.put(`/produtos/status/deletar/${id}`);

    const { status, message, data } = response.data;
    if (status) {
      handleClose();
      enqueueSnackbar('Produto deletado com sucesso!', {
        variant: 'success',
      });
    } else {
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        ativar(id);
        break;
      case 2:
        desativar(id);
        break;
      case 3:
        deletar(id);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setAtivos(ids);
          break;
        case STATUS_INATIVO:
          setInativos(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'ativos' ? STATUS_ATIVO : STATUS_INATIVO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  const handleClose = () => {
    refresh();
  };

  async function testeEstoque2(id) {
    const response = await api.get(`/testes/estoque2/${id}`);
  }

  function navegarCotacoes({ id }) {
    //testeEstoque2(id);
    history.push(`/cotacao-precos-produtos?produto_id=${id}`);
  }

  function navegarFluxoCaixa({ id }) {
    if (id) {
      history.push(`/relatorio-fluxo-caixa-produtos?produto_id=${id}`);
    }
  }

  function changeStatusSearch(record) {
    if (refDialogoChangeStatusSearch.current) {
      refDialogoChangeStatusSearch.current.handleOpen(record);
    }
  }

  function changeStatusRuptura(record) {
    if (refDialogoChangeStatusRuptura.current) {
      refDialogoChangeStatusRuptura.current.handleOpen(record);
    }
  }

  async function testeEstoque(id) {
    const response = await api.get(`/testes/estoque/${id}`);
  }

  function handlePrecificar(record) {
    //testeEstoque(record.id);
    if (refDialogoPrecificacao.current) {
      refDialogoPrecificacao.current.handleOpen(record);
    }
  }

  function acumularAreaTranferencia(produto) {
    if (refAreaCopiaCola.current) {
      const preco_venda = produto.preco_venda;
      const preco_oferta = getPrecoUnitarioVerdadeiroCaixa2(produto);
      const fator = getFator(produto);
      const label_unidade = getUnidade(produto);
      const preco =
        preco_venda > preco_oferta
          ? `${formatMoeda(preco_oferta * fator)} / ${label_unidade}`
          : `${formatMoeda(preco_venda * fator)} / ${label_unidade}`;
      refAreaCopiaCola.current.guardar(
        produto.id,
        `${produto.nome} - ${preco}`,
      );
    }
  }

  async function handleTesteNfceProduto(record) {
    const response = await api.get(`/get-nfce-produto/${record.id}`);
    const data = response.data;
    if (refDialogoTesteNfceVenda.current) {
      refDialogoTesteNfceVenda.current.handleOpen(
        `Produto: ${record.nome}`,
        JSON.stringify(data.sefaz, null, 2),
      );
    }
  }

  async function handleDefinirImagem(record) {
    if (refDialogoImagem.current) {
      refDialogoImagem.current.handleOpen(
        record.id,
        record.link_imagem,
        record.nome,
      );
    }
  }

  return (
    <>
      <Title title="Produtos" />
      <ListToolbar
        filters={props.filters}
        actions={
          <Actions handleCriar={handleCriar} podeCriar={podeCriar} {...props} />
        }
        {...props}
      />
      <AreaCopiaCola ref={refAreaCopiaCola} />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Divider />
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {abas.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: ativos }}>
              <Datagrid rowStyle={postRowStyle} {...props}>
                <TextField source="id" label="Id" />
                <TextField source="nome" label="Descrição" />
                <ValorField source="preco_venda" label="Preço de Venda" />
                <FunctionField
                  label="Custo Final"
                  render={(record) =>
                    record.preco_custo_final > 0
                      ? `${formatMoeda(
                          record.preco_custo_final * getFator(record),
                        )}  / ${getUnidade(record)}`
                      : '-'
                  }
                />
                <FunctionField
                  label="Margem de Contribuição Real (%)"
                  render={(record) =>
                    record.preco_custo_final > 0
                      ? `${round10(
                          ((record.preco_venda - record.preco_custo_final) /
                            record.preco_custo_final) *
                            100,
                          -2,
                        )}%`
                      : '-'
                  }
                />
                {/* <FunctionField
                  label="Preço de Compra Médio"
                  render={(record) =>
                    record.precoCompraMedio > 0
                      ? `${formatMoeda(
                          record.precoCompraMedio * getFator(record),
                        )} / ${getUnidade(record)}`
                      : '-'
                  }
                />
                <FunctionField
                  label="Preço de Compra Médio Imposto"
                  render={(record) =>
                    record.precoCompraMedio > 0
                      ? `${formatMoeda(
                          record.precoCompraMedioImpostos * getFator(record),
                        )}  / ${getUnidade(record)}`
                      : '-'
                  }
                />
                <FunctionField
                  label="Lucro"
                  render={(record) =>
                    record.precoCompraMedio > 0
                      ? `${formatMoeda(
                          (record.preco_venda - record.precoCompraMedio) *
                            getFator(record),
                        )}  / ${getUnidade(record)}`
                      : '-'
                  }
                />
                <FunctionField
                  label="Margem de Lucro (%)"
                  render={(record) =>
                    record.precoCompraMedio > 0
                      ? `${round10(
                          ((record.preco_venda - record.precoCompraMedio) /
                            record.precoCompraMedio) *
                            100,
                          -2,
                        )}%`
                      : '-'
                  }
                /> */}
                <FunctionField
                  label="Estoque"
                  render={(record) => getEstoqueLabel(record)}
                />
                {/*<TextField
                  source="pesoDisponivel"
                  label="Peso (Kg)"
                  sortable={false}
                />*/}
                <ReferenceField
                  label="Unidade"
                  source="unidade_id"
                  reference="unidades"
                  sortable={false}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <ReferenceField
                  label="Categoria"
                  source="categoria_id"
                  reference="categorias"
                  sortable={false}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  handleEdit={handleEdit}
                  handleShow={handleShow}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  podeDesativar={podeInativar}
                  handleDeletar={handleDeletar}
                  handleCotacoes={navegarCotacoes}
                  handleRelatorioEstoque={navegarFluxoCaixa}
                  changeStatusSearch={changeStatusSearch}
                  changeStatusRuptura={changeStatusRuptura}
                  handlePrecificar={handlePrecificar}
                  handleImprimirCartaz={handleImprimirCartaz}
                  handleCopiaColar={acumularAreaTranferencia}
                  handleTesteNfceProduto={handleTesteNfceProduto}
                  handleDefinirImagem={handleDefinirImagem}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_INATIVO && podeVerInativos && (
            <ListContextProvider value={{ ...listContext, ids: inativos }}>
              <Datagrid {...props}>
                <TextField source="id" label="Id" />
                <TextField source="nome" label="Descrição" />
                <ValorField source="preco_venda" label="Preço de Venda" />
                <FunctionField
                  label="Custo Final"
                  render={(record) =>
                    record.preco_custo_final > 0
                      ? `${formatMoeda(
                          record.preco_custo_final * getFator(record),
                        )}  / ${getUnidade(record)}`
                      : '-'
                  }
                />
                <FunctionField
                  label="Margem de Contribuição Real (%)"
                  render={(record) =>
                    record.preco_custo_final > 0
                      ? `${round10(
                          ((record.preco_venda - record.preco_custo_final) /
                            record.preco_custo_final) *
                            100,
                          -2,
                        )}%`
                      : '-'
                  }
                />
                {/*   <FunctionField
                  label="Preço de Compra Médio"
                  render={(record) =>
                    record.precoCompraMedio > 0
                      ? `${formatMoeda(
                          record.precoCompraMedio * getFator(record),
                        )}  / ${getUnidade(record)}`
                      : '-'
                  }
                />
                <FunctionField
                  label="Preço de Compra Médio Imposto"
                  render={(record) =>
                    record.precoCompraMedio > 0
                      ? `${formatMoeda(
                          record.precoCompraMedioImpostos * getFator(record),
                        )}  / ${getUnidade(record)}`
                      : '-'
                  }
                />
                <FunctionField
                  label="Lucro"
                  render={(record) =>
                    record.precoCompraMedio > 0
                      ? `${formatMoeda(
                          (record.preco_venda - record.precoCompraMedio) *
                            getFator(record),
                        )}  / ${getUnidade(record)}`
                      : '-'
                  }
                />
                <FunctionField
                  label="Margem de Lucro (%)"
                  render={(record) =>
                    record.precoCompraMedio > 0
                      ? `${round10(
                          ((record.preco_venda - record.precoCompraMedio) /
                            record.precoCompraMedio) *
                            100,
                          -2,
                        )}%`
                      : '-'
                  }
                /> */}
                {/*<FunctionField
                  label="Unidades"
                  render={(record) => getEstoqueLabel(record)}
                />
                <TextField
                  source="pesoDisponivel"
                  label="Peso (Kg)"
                  sortable={false}
                />*/}
                <ReferenceField
                  label="Unidade"
                  source="unidade_id"
                  reference="unidades"
                  sortable={false}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <ReferenceField
                  label="Categoria"
                  source="categoria_id"
                  reference="categorias"
                  sortable={false}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  handleEdit={handleEdit}
                  handleShow={handleShow}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  podeDesativar={podeInativar}
                  handleDeletar={handleDeletar}
                  handleCotacoes={navegarCotacoes}
                  handleRelatorioEstoque={navegarFluxoCaixa}
                  changeStatusSearch={changeStatusSearch}
                  changeStatusRuptura={changeStatusRuptura}
                  handleImprimirCartaz={handleImprimirCartaz}
                  handleCopiaColar={acumularAreaTranferencia}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} />
      <DialogoConferir ref={refDialogoConferir} />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
      <DialogoChangeSearch ref={refDialogoChangeStatusSearch} />
      <DialogoShowProduto ref={refDialogoShowProduto} />
      <DialogoChangeRuptura ref={refDialogoChangeStatusRuptura} />
      <DialogoPrecificacao ref={refDialogoPrecificacao} />
      <ContainerDialogoImprimirCartazes ref={refDialogoImprimirCartazes} />
      <DialogoTesteNfceVenda ref={refDialogoTesteNfceVenda} />
      <DialogoImagem
        ref={refDialogoImagem}
        handleClose={() => {
          refresh();
        }}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_PRODUTOS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Produtos"
      filterDefaultValues={{
        status: STATUS_ATIVO,
        is_kit: false,
        is_caixa: false,
        ofertasProdutos: true,
      }}
      component="div"
    />
  </ProtegerPagina>
);

export default List;
